// src/components/DevVerifyDialog.jsx
// 開発者の権限を使う前のメール確認【2026-10-16】
//   ログインはパスワードだけ。開発者の機能（開発者モード・運営者の画面など）は、
//   登録メールに届く6桁のコードを入れたときだけ使える（12時間）。
//   確かめると新しいトークンが返るので、それを保存して画面ごと読み込み直す。
import React, { useEffect, useRef, useState } from 'react';

const auth = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') });

export default function DevVerifyDialog({ onClose }) {
  const [step, setStep] = useState('intro'); // intro → sent
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const inputRef = useRef(null);

  useEffect(() => { if (step === 'sent' && inputRef.current) inputRef.current.focus(); }, [step]);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const send = async () => {
    if (busy) return;
    setBusy(true); setMsg('');
    try {
      const res = await fetch('/api/auth/dev-verify/start', { method: 'POST', headers: auth() });
      const d = await res.json().catch(() => ({}));
      if (d.success && d.disabled) { window.location.reload(); return; }
      if (d.success) { setStep('sent'); setMsg('登録メールにコードを送りました（15分有効）'); }
      else setMsg(d.message || 'コードを送れませんでした');
    } catch (_) {
      setMsg('ネットワークエラーで送れませんでした');
    }
    setBusy(false);
  };

  const confirm = async (e) => {
    e.preventDefault();
    if (busy || !/^\d{6}$/.test(code)) return;
    setBusy(true); setMsg('');
    try {
      const res = await fetch('/api/auth/dev-verify/confirm', { method: 'POST', headers: auth(), body: JSON.stringify({ code }) });
      const d = await res.json().catch(() => ({}));
      if (d.success && d.token) {
        localStorage.setItem('token', d.token);
        window.location.reload();
        return;
      }
      setMsg(d.message || '確かめられませんでした');
      if (d.code === 'TOO_MANY_ATTEMPTS' || d.code === 'CODE_EXPIRED') { setStep('intro'); setCode(''); }
    } catch (_) {
      setMsg('ネットワークエラーで確かめられませんでした');
    }
    setBusy(false);
  };

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="devverify-title"
         onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
         style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 1000,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 380, padding: '22px 22px 18px',
                    boxShadow: '0 20px 50px rgba(0,0,0,0.25)', color: '#1f2937' }}>
        <h2 id="devverify-title" style={{ margin: '0 0 8px', fontSize: '1.05rem' }}>開発者の本人確認</h2>
        <p style={{ margin: '0 0 14px', fontSize: '0.88rem', lineHeight: 1.6, color: '#4b5563' }}>
          開発者の機能（開発者モード・運営者の画面など）を使うには、登録メールに届く確認コードを入れてください。
          確かめると12時間使えます。
        </p>
        {step === 'intro' ? (
          <button type="button" className="btn-primary" onClick={send} disabled={busy} style={{ width: '100%' }}>
            {busy ? '送っています…' : '確認コードをメールで送る'}
          </button>
        ) : (
          <form onSubmit={confirm}>
            <input ref={inputRef} inputMode="numeric" autoComplete="one-time-code" maxLength={6}
                   value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                   placeholder="6桁のコード" aria-label="確認コード"
                   style={{ width: '100%', boxSizing: 'border-box', fontSize: '1.4rem', letterSpacing: '0.4em',
                            textAlign: 'center', padding: '10px 8px', border: '1px solid #d1d5db', borderRadius: 8, marginBottom: 10 }} />
            <button type="submit" className="btn-primary" disabled={busy || code.length !== 6} style={{ width: '100%' }}>
              {busy ? '確かめています…' : '確かめる'}
            </button>
            <button type="button" className="btn-link" onClick={send} disabled={busy}
                    style={{ display: 'block', margin: '10px auto 0', fontSize: '0.82rem' }}>
              コードを送り直す
            </button>
          </form>
        )}
        {msg && <p role="status" style={{ margin: '12px 0 0', fontSize: '0.85rem', color: '#374151' }}>{msg}</p>}
        <button type="button" className="btn-link" onClick={onClose}
                style={{ display: 'block', margin: '12px auto 0', fontSize: '0.82rem', color: '#6b7280' }}>
          閉じる
        </button>
      </div>
    </div>
  );
}
